class Offers
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'offers--bound'
            @.$disciplinesSettingsFiltersList = @.$el.querySelector '.offers__settings__filters__disciplines'
            @.$filtersHeadButtons = @.$el.querySelectorAll '.offers__filters__head button'
            @.$filtersLists = @.$el.querySelectorAll '.offers__filters__list'
            @.$filtersListButtons = @.$el.querySelectorAll '.offers__filters__list button'
            @.$loaderEl = @.$el.querySelector '.offers__loader'
            @.$loadMoreButton = @.$el.querySelector '.offers__load-more'
            @.$listEl = @.$el.querySelector '.offers__list'
            @.$locationsSettingsFiltersList = @.$el.querySelector '.offers__settings__filters__locations'
            @.$pageButtonEl = undefined
            @.$pageButtonTemplate = @.$el.querySelector '.offers__page-button-template'
            @.$resultsActiveCountEl = @.$el.querySelector '.offers__settings__results span:first-child'
            @.$resultsCountEl = @.$el.querySelector '.offers__settings__results span:last-child'

            @.activeDisciplineFilters = []
            @.activeLocationFilters = []
            @.api = @.$el.dataset?.api ? false
            @.apiMethod = @.$el.dataset?.apiMethod ? 'GET'
            @.filterOptions = []
            @.maxShownItems = @.$el.dataset?.maxShown ? 0
            @.offers = []
            @.restrictToFilters = @.$el.dataset?.rtf == 'true'

            @.$el.classList.add 'offers--bound'
            @.AppendPageButton()
            @.GetFilterOptions()
            if @.api
                @.ShowLoader true
                @.GetOffersData()
            @.InitEvents()
        return
    
    AppendOfferBoxes: ->
        self = @
        count = 1
        @.offers.forEach (offer) ->
            classes = ['offers__offer']
            self.$loadMoreButton.classList.add 'offers__load-more--hidden'
            if self.maxShownItems > 0
                if count > self.maxShownItems && offer.isRealOffer
                    classes.push 'offers__offer--hidden'
                    self.$loadMoreButton.classList.remove 'offers__load-more--hidden'
            offerBoxEl = window.CreateOfferBox {
                attrs: {
                    class: classes
                }
                disciplineId: offer.disciplineId
                locationId: offer.locationId
                offerId: offer.id
                offices: "#{offer.office}#{if offer.additionalOffices != "" then ",#{offer.additionalOffices}" else ""}"
                subline: if offer.isRealOffer then offer.description else offer.name
                title: if offer.isRealOffer then offer.name else offer.locationId
                unspecific: !offer.isRealOffer
            }
            self.$listEl.appendChild offerBoxEl
            offer.element = offerBoxEl
            if offer.isRealOffer
                count++
            return
        window.dispatchEvent new CustomEvent 'bind-components', { bubbles: false }
        @.$resultsCountEl.textContent = count - 1
        @.$el.classList.add 'offers--results'
        return
    
    AppendPageButton: ->
        if @.$pageButtonTemplate
            # check if a page button already exists
            existingPageButton = document.querySelector '.offers__page-button'
            if !existingPageButton
                pageButton = document.importNode(@.$pageButtonTemplate.content, true)
                document.getElementById 'content'
                    .appendChild pageButton
                @.$pageButtonEl = document.querySelector '.offers__page-button'
        return
    
    FilterOffers: ->
        self = @
        activeFilters = @.activeDisciplineFilters.length + @.activeLocationFilters.length
        activeOffers = 0
        @.offers.forEach (offer) ->
            if offer.isRealOffer
                disciplineIds = offer.disciplineId.split(",")
                locationIds = offer.locationId.split(",")
                offerFiltered = true
                offerMatchingDisciplineFilters = 0
                offerMatchingLocationFilters = 0
                if self.activeDisciplineFilters.length > 0
                    self.activeDisciplineFilters.forEach (disciplineFilter) ->
                        matchingValues = 0
                        disciplineFilter.values.forEach (disciplineFilterValue) ->
                            if disciplineIds.indexOf(disciplineFilterValue) >= 0
                                matchingValues++
                            return
                        if matchingValues > 0
                            offerFiltered = false
                            offerMatchingDisciplineFilters++
                        return
                if self.activeLocationFilters.length > 0
                    self.activeLocationFilters.forEach (locationFilter) ->
                        matchingValues = 0
                        locationFilter.values.forEach (locationFilterValue) ->
                            if locationIds.indexOf(locationFilterValue) >= 0
                                matchingValues++
                            return
                        if matchingValues > 0
                            offerFiltered = false
                            offerMatchingLocationFilters++
                        return
                if self.activeDisciplineFilters.length > 0 && offerMatchingDisciplineFilters > 0 && self.activeLocationFilters.length == 0 || self.activeDisciplineFilters.length == 0 && self.activeLocationFilters.length > 0 && offerMatchingLocationFilters > 0 || self.activeDisciplineFilters.length > 0 && offerMatchingDisciplineFilters > 0 && self.activeLocationFilters.length > 0 && offerMatchingLocationFilters > 0 || self.activeDisciplineFilters.length == 0 && self.activeLocationFilters.length == 0
                    activeOffers++
                else
                    offerFiltered = true
                if offerFiltered && activeFilters > 0 
                    if offer.element
                        offer.element.classList.add 'offers__offer--filtered'
                else
                    if offer.element
                        offer.element.classList.remove 'offers__offer--filtered'
                        if activeFilters > 0
                            offer.element.classList.remove 'offers__offer--hidden'
            return
        @.$listEl.classList.remove 'offers__list--no-results'
        if activeFilters > 0
            @.$el.classList.add 'offers--filtered'
            @.$resultsActiveCountEl.textContent = activeOffers
            if activeOffers < 1
                @.$listEl.classList.add 'offers__list--no-results'
        else
            @.$el.classList.remove 'offers--filtered'
            @.$resultsActiveCountEl.textContent = ""
        return
    
    GetFilterOptions: ->
        self = @
        @.$filtersListButtons.forEach (filtersListButton) ->
            discipline = if filtersListButton.dataset?.discipline != "all" then (filtersListButton.dataset?.discipline ? false) else false
            location = if filtersListButton.dataset?.location != "all" then (filtersListButton.dataset?.location ? false) else false
            if discipline || location
                if discipline
                    if typeof self.filterOptions['disciplines'] == "undefined"
                        self.filterOptions['disciplines'] = []
                    self.filterOptions['disciplines'].push {
                        element: filtersListButton
                        matchingOffers: 0
                        values: discipline.split(",")
                    }
                if location
                    if typeof self.filterOptions['locations'] == "undefined"
                        self.filterOptions['locations'] = []
                    self.filterOptions['locations'].push {
                        element: filtersListButton
                        matchingOffers: 0
                        values: location.split(',')
                    }
            return
        console.log "FILTER OPTIONS", @.filterOptions
        return
    
    GetOffersData: ->
        if @.api && @.apiMethod != ""
            self = @
            await fetch @.api, {
                method: @.apiMethod
                mode: 'same-origin'
            }
                .then (response) ->
                    self.ShowLoader false
                    switch response.status
                        when 200
                            return response.text()
                        else
                            console.log "Die Rückmeldung der API für Stellenangebote war nicht erfolgreich. Status-Code: #{ response.status }"
                    return
                .then (responseText) ->
                    if responseText
                        responseText = JSON.parse responseText
                        self.PrepareOffersList responseText
                    return
                .catch (error) ->
                    self.ShowLoader false
                    console.log "Fehler beim Versuch die API für Stellenangebote zu erreichen oder zu verarbeiten: #{ error }"
                    return
        return

    InitEvents: ->
        self = @
        # filters head buttons switch
        @.$filtersHeadButtons.forEach (filtersHeadButton) ->
            filtersHeadButton.addEventListener 'click', (e) ->
                e.preventDefault()
                filterType = @.dataset?.type ? false
                if filterType
                    self.$el.querySelector '.offers__filters__head__button--active'
                        .classList.remove 'offers__filters__head__button--active'
                    @.classList.add 'offers__filters__head__button--active'
                    self.$filtersLists.forEach (filtersListEl) ->
                        filtersListEl.classList.remove 'offers__filters__list--active'
                        if filtersListEl.dataset?.type == filterType
                            filtersListEl.classList.add 'offers__filters__list--active'
                        return
                return
            return
        # filters lists buttons action
        @.$filtersListButtons.forEach (filtersListButton) ->
            filtersListButton.addEventListener 'click', (e) ->
                e.preventDefault()
                disciplineId = @.dataset?.discipline ? false
                locationId = @.dataset?.location ? false
                if disciplineId
                    filterType = "discipline"
                    filter = disciplineId
                if locationId
                    filterType = "location"
                    filter = locationId
                if filter != "all"
                    @.classList.toggle 'offers__filters__list__button--active'
                    filterName = window.appUtils.TextContentWithoutChildNodes @
                    self.ToggleFilter filterType, filter, filterName, !@.classList.contains('offers__filters__list__button--active')
                else
                    @.classList.add 'offers__filters__list__button--active'
                    self.ResetFilters filterType
                return
        # load more button
        @.$loadMoreButton.addEventListener 'click', (e) ->
            e.preventDefault()
            self.ShowAllOffers()
            return
        # page button
        if @.$pageButtonEl
            document.addEventListener 'scroll', (e) ->
                elBCR = self.$el.getBoundingClientRect()
                if elBCR.top + document.documentElement.scrollTop <= window.scrollY + window.innerHeight && (elBCR.top + document.documentElement.scrollTop + elBCR.height - document.querySelector('.header').offsetHeight) >= window.scrollY 
                    self.$pageButtonEl.classList.add 'offers__page-button--hidden'
                else
                    self.$pageButtonEl.classList.remove 'offers__page-button--hidden'
                return
            @.$pageButtonEl.addEventListener 'click', (e) ->
                e.preventDefault()
                window.scrollTo {
                    behavior: 'smooth'
                    left: 0
                    top: self.$el.getBoundingClientRect().top + document.documentElement.scrollTop - document.querySelector('.header').offsetHeight
                }
                return
        return
    
    PrepareOffersList: (responseOffers) ->
        self = @
        console.log "RESPONSE OFFERS", responseOffers
        if responseOffers
            responseOffers.forEach (responseOffer) ->
                if responseOffer.isRealOffer
                    responseOffer['element'] = undefined
                    includeOffer = !self.restrictToFilters || !responseOffer.isRealOffer
                    disciplines = responseOffer.disciplineId.split(",")
                    locations = responseOffer.locationId.split(",")
                    if self.filterOptions.disciplines
                        self.filterOptions.disciplines.forEach (disciplineFilter) ->
                            matchingOffers = 0
                            disciplineFilter.values.forEach (disciplineFilterValue) ->
                                if disciplines.indexOf(disciplineFilterValue) >= 0
                                    includeOffer = true
                                    matchingOffers++
                                return
                            disciplineFilter.matchingOffers += matchingOffers
                            return
                    if self.filterOptions.locations
                        self.filterOptions.locations.forEach (locationFilter) ->
                            matchingOffers = 0
                            locationFilter.values.forEach (locationFilterValue) ->
                                if locations.indexOf(locationFilterValue) >= 0
                                    includeOffer = true
                                    matchingOffers++
                            locationFilter.matchingOffers += matchingOffers
                            return
                    if includeOffer
                        self.offers.push responseOffer
                return
        if @.filterOptions.disciplines
            @.filterOptions.disciplines = @.filterOptions.disciplines.filter (disciplineFilter) ->
                if disciplineFilter.matchingOffers > 0
                    disciplineFilter.element.querySelector 'span'
                        .textContent = disciplineFilter.matchingOffers
                else
                    disciplineFilter.element.remove()
                return disciplineFilter.matchingOffers > 0
            if @.filterOptions.disciplines.length < 1
                disciplinesHeadFilterButton = @.$el.querySelector '.offers__filters__head button[data-type="disciplines"]'
                if disciplinesHeadFilterButton
                    disciplinesHeadFilterButton.remove()
                disciplinesFiltersListEl = @.$el.querySelector '.offers__filters__list[data-type="disciplines"]'
                if disciplinesFiltersListEl
                    disciplinesFiltersListEl.remove()
        if @.filterOptions.locations
            @.filterOptions.locations = @.filterOptions.locations.filter (locationFilter) ->
                if locationFilter.matchingOffers > 0
                    locationFilter.element.querySelector 'span'
                        .textContent = locationFilter.matchingOffers
                else
                    locationFilter.element.remove()
                return locationFilter.matchingOffers > 0
            if @.filterOptions.locations.length < 1
                locationsHeadFilterButton = @.$el.querySelector '.offers__filters__head button[data-type="locations"]'
                if locationsHeadFilterButton
                    locationsHeadFilterButton.remove()
                locationsFiltersListEl = @.$el.querySelector '.offers__filters__list[data-type="locations"]'
                if locationsFiltersListEl
                    locationsFiltersListEl.remove()
        if @.filterOptions.disciplines?.length < 1 && @.filterOptions.locations?.length < 1
            @.$el.classList.add 'offers--no-filters'
            
        self.AppendOfferBoxes()
        return
    
    ResetFilters: (filterType) ->
        self = @
        activeFilterButtons = @.$el.querySelectorAll ".offers__filters__list[data-type='#{ filterType }s'] button.offers__filters__list__button--active:not(button[data-#{ filterType }='all'])"
        activeFilterButtons.forEach (activeFilterButton) ->
            if filterType == 'location'
                filter = activeFilterButton.dataset?.location ? false
            else
                filter = activeFilterButton.dataset?.discipline ? false
            activeFilterButton.classList.remove 'offers__filters__list__button--active'
            self.ToggleFilter filterType, filter, "", true
            return
        allFilterButton = @.$el.querySelector ".offers__filters__list[data-type='#{ filterType }s'] button[data-#{ filterType }='all']"
        if allFilterButton
            allFilterButton.classList.add 'offers__filters__list__button--active'
        return

    ShowAllOffers: ->
        @.$listEl.querySelectorAll '.offers__offer'
            .forEach (offerBoxEl) ->
                offerBoxEl.classList.remove 'offers__offer--hidden'
                return
        @.$loadMoreButton.classList.add 'offers__load-more--hidden'
        return

    ShowLoader: (shown) ->
        if shown
            @.$loaderEl.classList.add 'offers__loader--shown'
        else
            @.$loaderEl.classList.remove 'offers__loader--shown'
        return
    
    ToggleAllButtonAndFilterClasses: (filterType) ->
        allFilterButton = @.$el.querySelector ".offers__filters__list[data-type='#{ filterType }s'] button[data-#{ filterType }='all']"
        activeFilterButtons = @.$el.querySelectorAll ".offers__filters__list[data-type='#{ filterType }s'] button.offers__filters__list__button--active:not(button[data-#{ filterType }='all'])"
        if activeFilterButtons.length > 0
            allFilterButton.classList.remove 'offers__filters__list__button--active'
            @.$el.classList.add "offers--#{ filterType }-filter"
        else
            allFilterButton.classList.add 'offers__filters__list__button--active'
            @.$el.classList.remove "offers--#{ filterType }-filter"
        return
    
    ToggleFilter: (filterType, filter, filterName, remove) ->
        self = @
        filterValues = filter.split(",")
        if filterType && filter
            if !remove
                filterTagEl = window.CreateFilterTag {
                    filterType: filterType
                    filterValue: filter
                    text: filterName
                }
            if filterType == "location"
                if @.filterOptions.locations
                    @.filterOptions.locations.forEach (locationFilter) ->
                        locationFilter.values.forEach (locationFilterValue) ->
                            if filterValues.indexOf(locationFilterValue) >= 0
                                activeFilterIndex = window.appUtils.IndexOfObject locationFilter, self.activeLocationFilters
                                if !remove
                                    if activeFilterIndex < 0
                                        self.activeLocationFilters.push locationFilter
                                else
                                    if activeFilterIndex >= 0
                                        self.activeLocationFilters.splice(activeFilterIndex,1)
                        return
                if !remove
                    @.$locationsSettingsFiltersList.appendChild filterTagEl
                    window.dispatchEvent new CustomEvent 'bind-components', { bubbles: false }
                else
                    filterTagEl = @.$locationsSettingsFiltersList.querySelector ".filter-tag[data-filter-type='#{ filterType }'][data-filter-value='#{ filter }']"
                    if filterTagEl
                        filterTagEl.dispatchEvent new CustomEvent 'filter-tag-remove', { bubbles: false }
            else
                if @.filterOptions.disciplines
                    @.filterOptions.disciplines.forEach (disciplineFilter) ->
                        activeFilterIndex = window.appUtils.IndexOfObject disciplineFilter, self.activeDisciplineFilters
                        disciplineFilter.values.forEach (disciplineFilterValue) ->
                            if filterValues.indexOf(disciplineFilterValue) >= 0
                                if !remove
                                    if activeFilterIndex < 0
                                        self.activeDisciplineFilters.push disciplineFilter
                                else
                                    if activeFilterIndex >= 0
                                        self.activeDisciplineFilters.splice(activeFilterIndex,1)
                        return
                if !remove
                    @.$disciplinesSettingsFiltersList.appendChild filterTagEl
                    window.dispatchEvent new CustomEvent 'bind-components', { bubbles: false }
                else
                    filterTagEl = @.$disciplinesSettingsFiltersList.querySelector ".filter-tag[data-filter-type='#{ filterType }'][data-filter-value='#{ filter }']"
                    if filterTagEl
                        filterTagEl.dispatchEvent new CustomEvent 'filter-tag-remove', { bubbles: false }
            if !remove
                if filterTagEl
                    filterTagEl.addEventListener 'filter-tag-delete', (e) ->
                        filterType = e.detail?.filterType ? false
                        filterValue = e.detail?.filterValue ? false
                        if filterType && filterValue
                            matchingFiltersButton = self.$el.querySelector ".offers__filters__list[data-type='#{ filterType }s'] button[data-#{ filterType }='#{ filterValue }']"
                            if matchingFiltersButton
                                matchingFiltersButton.click()
                        return
            @.ToggleAllButtonAndFilterClasses filterType
            @.FilterOffers()
        return

BindOffers = ->
    document.querySelectorAll '.offers:not(.offers--bound)'
        .forEach (el) ->
            new Offers el
            return
    return

window.addEventListener 'bind-components', BindOffers